import Styled, { css } from 'styled-components'
import { BaseSlot } from '../../../domain/entities'

export const ActionIconsContainer = Styled.div<{ state: string; hovered: boolean }>`
  width:auto;
  height: 2.4rem;
  display:flex;
  justify-content:flex-end;
  align-items:center;

  & > .icon{
    display:${({ hovered }) => (hovered ? 'flex' : 'none')};
    align-items:center;
    justify-content:center;
    width:1.5rem;
    height:1.5rem;
  }
  & > .circle{
    margin: 0 1rem 0 1rem;
  }
  & > .poweroff{
    color: ${({ state }) => (state === 'TURNED_OFF' ? '#1677FF' : '#CF1322')};
  }
`
export const StateIconLabel = Styled.span<{ state: string; parentWidth: number; hovered: boolean }>`
  width: auto;
  min-width: 2.4rem;
  height: 2.4rem;
  display: ${({ state, hovered, parentWidth }) =>
    (state !== 'AVAILABLE' && parentWidth > 148 && hovered) || (state !== 'AVAILABLE' && !hovered) ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  padding: 2px 6px 2px 6px;
  border-radius: 12px;
  font-size: 1.2rem;
  background: ${({ state }) => (state === 'TURNED_OFF' ? 'rgba(82, 84, 89, 1)' : '#FFCCC7')};
  color: ${({ state }) => (state === 'TURNED_OFF' ? '#ffffff' : '#CF1322')};

  & > svg{
    width: 11.5px;
    height: 11.5px;
  }
  & > .label{
    display: ${({ parentWidth, hovered }) => (parentWidth >= 202 || (hovered && parentWidth > 202) ? 'block' : 'none')};
  }
`
export const ProgressBarContainer = Styled.section<{ days: number }>`
  width: calc(100% - 32px);
  height: auto;
  display: grid;
  grid-template-columns: ${({ days }) => `repeat(${days}, 1fr)`};
  grid-template-rows: repeat(605, 3px);
  column-gap: ${({ days }) => `calc(32px/${days})`};
  padding-right: 8px;
  padding-left: calc(4% + 8px);
  position: absolute;
  top: 8px;
  z-index: 1;
  pointer-events: none;
`
export const StyledProgressBar = Styled.div<{ startMin: number }>`
  width: 100%;
  height: 3px;
  background: #F5222D;
  position: relative;
  left: -12px;
  grid-column-start:1;
  grid-row-start:${({ startMin }) => startMin};
`
export const HourIndicatorCircle = Styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #F5222D;
  position: absolute;
  top: -4.5px;
  left: -12px;
`
export const Hours = Styled.div<{ expired: boolean; minHeight: boolean }>`
  display:flex;
  flex-direction:${({ minHeight }) => (minHeight ? 'row' : 'column')};
  align-items:${({ minHeight }) => (minHeight ? 'center' : 'flex-start')};
  & > .duration:first-child {
    font-size: 1.2rem;
    color: ${({ expired }) => (expired ? 'rgba(0, 0, 0, 0.45)' : 'black')};
  }
  & > .hours{
    font-size: ${({ minHeight }) => (minHeight ? '12px' : '14px')};
    margin-right: ${({ minHeight }) => (minHeight ? '8px' : '0')};
    color: ${({ expired }) => (expired ? 'rgba(0, 0, 0, 0.45)' : 'black')};
  }
  & > .duration, .static-duration{
    font-size: 1.2rem;
    color: ${({ expired }) => (expired ? 'rgba(0, 0, 0, 0.45)' : 'rgba(0, 0, 0, 0.55)')};
  }
`
export const StaticScheduleBoard = Styled.article`
  width: 100%;
  height: 60rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  min-width: 25rem;
  margin: 2rem 0 0 0;
`
export const StaticScheduleTableHeader = Styled.table<{ days: number }>`
  width: 100%;

  & .cell-day{
    width: ${({ days }) => `calc(96%/${days})`};
    border-right: 1px solid #dde0e5;
    border-bottom: 1px solid #dde0e5;
    border-left: 1px solid #dde0e5;
  }
  & .cell-hour{
    width: 4%;
    height: 7.6rem;
    position: relative;
    border-right: 1px solid #dde0e5;
    &::after{
      content: '';
      position: absolute;
      bottom: -0.5px;
      right: 0px;
      width: 50%;
      height: 1px;
      background: #dde0e5;
    }
    & > .hour{
      color: rgba(0, 0, 0, 0.65);
      position: absolute;
      bottom: -11px;
      left: 10px;
      z-index: 1;
    }
  }
`
export const StaticScheduleContainer = Styled.article`
  width: 100%;
  height: 52rem;
  min-width: 25rem;
  position: relative;
  overflow-y: auto;

  ${() =>
    css`
      &::-webkit-scrollbar {
        display: none;
      }
    `}
  `
export const StaticScheduleTable = Styled.table`
  width: 100%;

  & .cell-slot{
    border: 1px solid #dde0e5;
  }
  & .cell-hour{
    width: 4%;
    height: 7.6rem;
    position: relative;
    border-right: 1px solid #dde0e5;
    &::after{
      content: '';
      position: absolute;
      bottom: -0.5px;
      right: 0px;
      width: 50%;
      height: 1px;
      background: #dde0e5;
    }
    & > .hour{
      color: rgba(0, 0, 0, 0.65);
      position: absolute;
      bottom: -11px;
      left: 10px;
      z-index: 1;
    }
  }

`
export const SlotsBoard = Styled.section<{ days: number }>`
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: ${({ days }) => `repeat(${days}, 1fr)`};
  grid-template-rows: repeat(1815, 1px);
  column-gap: ${({ days }) => `calc(32px/${days})`};
  padding-right: 8px;
  padding-left: calc(4% + 8px);
  position: absolute;
  top: 8px;
  z-index:1;
`
export const OperationModelListContainer = Styled.section`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0;
  margin: 2.4rem 0 0 0;

  & > span {
    font-size: 1.2rem;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 1.2rem;
  }
`
export const ExpiredGrid = Styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left:0;
  z-index: 2;
  border-radius: 6px;

  &::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: repeating-linear-gradient(-45deg, transparent, transparent 4px, rgba(0,0,0,0.08) 4px, rgba(0,0,0,0.08) 8px);
  border-radius: 6px;
}
`
type StateContainerProps = {
  state: BaseSlot['state']
  expired: boolean
  height: number
  isExpress: boolean
  startDay: number
  startMin: number
}
const getBackgroundColor = (state: BaseSlot['state'], expired: boolean, isExpress: boolean) => {
  if (
    (state === 'AVAILABLE' && !isExpress) ||
    (expired && !isExpress && (state === 'TURNED_OFF' || state === 'CLOSED'))
  ) {
    return '#f3f5f9'
  } else if (state === 'AVAILABLE' || expired) {
    return 'white'
  } else if (state === 'CLOSED') {
    return '#FFF1F0'
  } else if (state === 'TURNED_OFF') {
    return '#DDE0E5'
  }
  return ''
}
export const SlotContainerCard = Styled.article<StateContainerProps>`
  width: auto;
  height: ${({ height }) => (height ? `calc(${height}px * 1.27 - 16px)` : 'auto')};
  min-width:11.5rem;
  min-height:2.8rem;
  display:flex;
  justify-content:space-between;
  align-items:flex-start;
  border-radius: 6px;
  padding: ${({ height, isExpress }) => (height <= 40 && !isExpress ? '2px 8px 2px 8px' : '8px')};
  background: ${({ state, expired, isExpress }) => getBackgroundColor(state, expired, isExpress)};
  margin-bottom: 0.8rem;
  position:relative;
  grid-column-start:${({ startDay }) => startDay};
  grid-row-start:${({ startMin }) => startMin};


  &:hover{
    box-shadow:${({ expired }) =>
      !expired
        ? '0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05)'
        : ''};
    cursor: pointer;
  }
`
export const CollapsibleContainer = Styled.article<{ large?: boolean }>`
  width: 100%;
  height: auto;
  margin-bottom: ${({ large }) => (large ? '2.4rem' : '0.8rem')};
`
export const CollapsibleHeader = Styled.header<{ primaryColor: string; large?: boolean; show: boolean }>`
    width: 100%;
    height: ${({ large }) => (large ? `5.4rem` : '4rem')};
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #dde0e5;
    border-radius: ${({ show, large }) => {
      const hidenRadius = large ? '0.8rem' : '0.6rem'
      const showRadius = large ? '0.8rem 0.8rem 0 0' : '0.6rem 0.6rem 0 0'
      return show ? showRadius : hidenRadius
    }};
    padding: 8px 16px 8px 16px;
    background: ${({ large }) => (large ? '#ffffff' : '#f3f5f9')};

    @media (max-width: 730px) {
      height: auto;
      flex-direction: ${({ large }) => (large ? 'row' : 'column')};
    }
    & > p {
      font-size: ${({ large }) => (large ? '2rem' : '1.6rem')};
      font-style: normal;
      font-weight: ${({ large }) => (large ? '500' : 'normal')};
      line-height: ${({ large }) => (large ? '2.8rem' : '2.5rem')};
      margin: 0;
      color: black;
    }
    & > div {
      width: 40rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: rgba(0, 0, 0, 0.45);
      @media (max-width: 730px) {
      justify-content: ${({ large }) => (large ? 'flex-end' : 'center')};
    }
      & > span:first-child {
        width: 1.4rem;
        height: 1.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 1rem;
        & > svg {
          width: 14px;
          height: 15px;
        }
      }
      & > .icon {
        width: 11px;
        height: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
        & > svg {
          width: 11px;
          height: 12px;
        }
      }
      & > p {
        margin: 0 18px 0 0;
      }
      & > .available-slots{
        color: black;
        font-weight: bold;
      }
      & > span:last-child {
        color: ${({ primaryColor }) => primaryColor};
        width: ${({ large }) => (large ? '2rem' : '1.4rem')};
        height: ${({ large }) => (large ? '2rem' : '1.5rem')};
        & > svg{
          font-size: ${({ large }) => (large ? '2rem' : '1.4rem')};
          width: ${({ large }) => (large ? '2rem' : '1.4rem')};
          height: ${({ large }) => (large ? '2rem' : '1.5rem')};
        }
      }
  }
`
export const CollapsibleBody = Styled.section<{ show: boolean }>`
  width: 100%;
  height: ${({ show }) => (show ? 'auto' : '0')};
  display: flex;
  justify-content: flex-start;
  border-left: ${({ show }) => (show ? '1px solid #dde0e5' : 'none')};
  border-right: ${({ show }) => (show ? '1px solid #dde0e5' : 'none')};
  border-bottom: ${({ show }) => (show ? '1px solid #dde0e5' : 'none')};
  transition: height 0.5s linear, border-bottom 0.5s linear, border-left 0.5s linear, border-right 0.5s linear;
  @media (max-width:768px){
    flex-direction: column;
  }
`
export const ExpressSlotsContainer = Styled.article`
  width: 23.6rem;
  min-width: 23.6rem;
  height: 60rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 16px 12px 0 16px;
  border: 1px solid #dde0e5;
  border-radius: 8px;
  padding: 16px;
  background: #f3f5f9;
  & > h3 {
    font-size: 14px;
  }
  & > section {
    width: 100%;
    height: auto;
  }
`
export const TurnOffModal = Styled.article`
  margin-left: 1.7rem;
  & > p:first-child{
    font-size: 1.6rem;
    margin-bottom: 0.8rem;
    color: black;
  }
  & > p:nth-child(2){
    font-size: 1.4rem;
    margin-bottom: 0.8rem;
  }
  & > div{
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
`
